import styled from '@emotion/styled';
import { Swiper } from 'swiper/react';

import Card from 'components/global/Card';

import { Breakpoints } from 'utils/const.styles';

export const ContentContainer = styled.div`
	width: 100%;
	padding: 2rem;

	@media ${Breakpoints.tablet} {
		padding: 1rem !important;
	}
`;

export const RightSide = styled.div`
	width: 352px;
	display: flex;
	flex-direction: column;
	gap: 2rem;

	@media ${Breakpoints.tablet} {
		padding-top: 1rem;
		width: 100%;
	}
`;

export const LeftSide = styled.div`
	width: calc(100% - 352px);
	display: flex;
	flex-direction: column;
	gap: 2rem;

	> .alert img {
		height: 7rem;
		width: 7rem;
	}
	.alert-link > .typography {
		text-decoration: none !important;
	}
	@media ${Breakpoints.tablet} {
		padding-top: 1rem;
		width: 100%;
	}
`;

export const Announcements = styled(Card)`
	width: 352px;
	height: 525px;
	border: none !important;

	@media ${Breakpoints.tablet} {
		width: 100%;
		height: 525px;
	}
`;

export const DesktopView = styled.div`
	display: flex;
	flex-direction: row;
	gap: 2rem;
	width: 100%;
`;

export const SwiperWrapper = styled(Swiper)`
	height: 100%;
	background: linear-gradient(to bottom, #253999, var(--blue));

	& > .swiper-pagination {
		bottom: 3rem !important;
	}
`;

export const PageHeader = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	width: 100%;
	margin-bottom: 2.5rem;

	@media ${Breakpoints.tablet} {
		padding: 1rem !important;
	}
`;

export const OtoPerksAnnouncement = styled.div`
	border-radius: var(--small-border-radius);
	background: var(--white);
	border: 1px solid var(--border-color);
	padding: 0 2rem;
	position: relative;
	display: flex;
	flex-direction: row;
	width: 100%;
`;

export const OtoPerksAnnouncementImage = styled.div`
	display: flex;
	align-items: flex-end;
	height: 100%;
`;

export const OtoPerksAnnouncementContent = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: 100%;

	@media ${Breakpoints.mobile} {
		flex-direction: column;
		gap: 2rem;
		padding: 2rem 0;
	}
`;

export const OtoPerksAnnouncementText = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 0.5rem;
	padding: 2rem 3rem;

	@media ${Breakpoints.mobile} {
		padding: 0 2rem;
	}
`;

export const OtoPerksAnnouncementButton = styled.div`
	display: flex;
	align-items: center;

	@media ${Breakpoints.mobile} {
		padding: 0 2rem;
	}
`;
